import { GET_CUSTOMER_WHD_REQUEST, GET_CUSTOMER_WHD_SUCCESS, GET_CUSTOMER_WHD_FAILURE, RESET_WHD_RATES } from 'actions';

// eslint-disable-next-line default-param-last
function withholding(state = {
  isGettingWhd: false,
  accountId: null,
  customerId: null,
  accountWithholdingRates: null
}, action) {
  switch (action.type) {
    case GET_CUSTOMER_WHD_REQUEST:
      return {
        ...state,
        isGettingWhd: true,
        accountId: action.accountId,
        customerId: action.customerId,
        accountWithholdingRates: null
      };
    case GET_CUSTOMER_WHD_SUCCESS:
      return {
        ...state,
        isGettingWhd: false,
        accountId: action.accountId,
        customerId: action.customerId,
        accountWithholdingRates: action.accountWithholdingRates
      };
    case GET_CUSTOMER_WHD_FAILURE:
      return {
        ...state,
        isGettingWhd: false,
        accountId: action.accountId,
        customerId: action.customerId,
        accountWithholdingRates: null
      };
    case RESET_WHD_RATES:
      return {
        ...state,
        accountWithholdingRates: null
      };
    default:
      return state;
  }
}

export default withholding;
